import styled, { css } from 'styled-components';
import { themeVal, glsp, rem, multiply } from '@devseed-ui/theme-provider';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject$2, _templateObject2$1, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

var renderHeadingVariation = function renderHeadingVariation() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var variation = props.variation;

  if (!variation) {
    return css(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n      color: inherit;\n    "])));
  } else {
    return css(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n      color: ", ";\n    "])), themeVal(['color', variation]));
  }
};

var sizeMapping = {
  xxsmall: '0.75rem',
  xsmall: '1rem',
  small: '1.25rem',
  medium: '1.5rem',
  large: '1.75rem',
  xlarge: '2rem',
  xxlarge: '2.25rem',
  jumbo: '3rem'
};
var renderHeadingSize = function renderHeadingSize() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size;
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    font-size: ", ";\n    ", "\n  "])), sizeMapping[size], size === 'xxsmall' && 'line-height: 1rem;');
};
var createHeadingStyles = function createHeadingStyles(props) {
  return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  text-transform: ", ";\n  font-weight: ", ";\n  font-style: ", ";\n  font-variation-settings: ", ";\n\n  /* Variation */\n  ", "\n\n  /* Size */\n  ", "\n"])), themeVal('type.heading.family'), themeVal('type.heading.case'), themeVal('type.heading.weight'), themeVal('type.heading.style'), themeVal('type.heading.settings'), renderHeadingVariation(props), renderHeadingSize(props));
};
var createOverlineStyles = function createOverlineStyles() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: 0.75rem;\n  line-height: 1rem;\n  font-family: ", ";\n  font-weight: ", ";\n  text-transform: ", ";\n  font-feature-settings: ", ";\n\n  /* Variation */\n  ", "\n"])), themeVal('type.overline.family'), themeVal('type.overline.regular'), themeVal('type.overline.textTransform'), themeVal('type.overline.settings'), renderHeadingVariation(_objectSpread2(_objectSpread2({}, props), {}, {
    variation: props.variation || 'base-400'
  })));
};
var createSubtitleStyles = function createSubtitleStyles() {
  return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-size: 0.75rem;\n  line-height: 1rem;\n  color: ", ";\n"])), themeVal('color.base-400'));
};
var Heading = /*#__PURE__*/styled.h1.withConfig({
  displayName: "Heading",
  componentId: "sc-17hljlf-0"
})(["", ""], createHeadingStyles);
var Overline = /*#__PURE__*/styled.p.withConfig({
  displayName: "Heading__Overline",
  componentId: "sc-17hljlf-1"
})(["", ""], createOverlineStyles);
var Lead = /*#__PURE__*/styled.p.withConfig({
  displayName: "Heading__Lead",
  componentId: "sc-17hljlf-2"
})(["font-size:", ";color:", ";"], themeVal('type.base.leadSize'), themeVal('color.base-400'));
var Subtitle = /*#__PURE__*/styled.p.withConfig({
  displayName: "Heading__Subtitle",
  componentId: "sc-17hljlf-3"
})(["", ""], createSubtitleStyles);

var _templateObject$1;
var proseSpacing = 1.5;
var createProseStyles = function createProseStyles() {
  return css(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  sup,\n  sub {\n    font-size: 0.75em;\n  }\n\n  sup {\n    vertical-align: top;\n  }\n\n  sub {\n    vertical-align: bottom;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    ", "\n    margin-bottom: ", ";\n\n    &:not(:first-child) {\n      margin-top: ", ";\n    }\n  }\n\n  h1 {\n    ", "\n  }\n\n  h2 {\n    ", "\n  }\n\n  h3 {\n    ", "\n  }\n\n  h4 {\n    ", "\n  }\n\n  h5 {\n    ", "\n  }\n\n  h6 {\n    ", "\n  }\n\n  dl {\n    padding: 0;\n  }\n\n  ol ol,\n  ol ul,\n  ul ol,\n  ul ul {\n    margin-bottom: 0;\n  }\n\n  dt {\n    font-weight: ", ";\n  }\n\n  figure > figcaption {\n    ", "\n    padding: ", ";\n    text-align: center;\n    width: 100%;\n    max-width: 52rem;\n    margin: 0 auto;\n  }\n\n  figure img {\n    display: block;\n    margin: 0 auto;\n  }\n\n  > * {\n    margin-bottom: ", ";\n  }\n\n  > *:last-child {\n    margin-bottom: 0;\n  }\n\n  table {\n    ", "\n\n    &.table-zebra {\n      ", "\n    }\n  }\n"])), createHeadingStyles, glsp(), glsp(proseSpacing * 2), renderHeadingSize({
    size: 'xxlarge'
  }), renderHeadingSize({
    size: 'xlarge'
  }), renderHeadingSize({
    size: 'large'
  }), renderHeadingSize({
    size: 'medium'
  }), renderHeadingSize({
    size: 'small'
  }), renderHeadingSize({
    size: 'xsmall'
  }), themeVal('type.base.bold'), createSubtitleStyles, glsp(), rem(proseSpacing), createTableStyles, renderTableZebra({
    zebra: true
  }));
};
var Prose = /*#__PURE__*/styled.div.withConfig({
  displayName: "Prose",
  componentId: "sc-1p4enbu-0"
})(["", ""], createProseStyles);

var _templateObject, _templateObject2;
var renderTableZebra = function renderTableZebra() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      zebra = _ref.zebra;

  return zebra && css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    tbody tr:nth-of-type(odd) {\n      background: ", ";\n    }\n  "])), themeVal('color.base-50a'));
};
var createTableStyles = function createTableStyles(props) {
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 100%;\n  border-color: ", ";\n  border-collapse: collapse;\n\n  tbody,\n  td,\n  tfoot,\n  th,\n  thead,\n  tr {\n    border-color: inherit;\n    border-bottom-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-bottom-width: 0px;\n  }\n\n  & > *:not(caption) > * > * {\n    border-bottom-width: ", ";\n  }\n\n  & > :not(:last-child) > :last-child > * {\n    border-bottom-width: ", ";\n  }\n\n  th {\n    ", "\n  }\n\n  td,\n  th {\n    padding: ", ";\n    vertical-align: top;\n    text-align: left;\n  }\n\n  th:first-child,\n  td:first-child {\n    padding-left: ", ";\n  }\n\n  th:last-child,\n  td:last-child {\n    padding-right: ", ";\n  }\n\n  /* Table zebra */\n  ", "\n\n  caption {\n    ", "\n    caption-side: bottom;\n    padding: ", ";\n    text-align: center;\n  }\n"])), themeVal('color.base-200a'), themeVal('layout.border'), multiply(themeVal('layout.border'), 2), createHeadingStyles({
    size: 'xsmall'
  }), glsp(1 / 4), glsp(), glsp(), renderTableZebra(props), createSubtitleStyles, glsp());
};
var Table = /*#__PURE__*/styled.table.withConfig({
  displayName: "Table",
  componentId: "sc-1f22pod-0"
})(["", ""], createTableStyles);

export { Heading, Lead, Overline, Prose, Subtitle, Table, createHeadingStyles, createOverlineStyles, createProseStyles, createSubtitleStyles, createTableStyles, renderHeadingSize, renderTableZebra };
//# sourceMappingURL=index.es.js.map
